// @flow

import * as React from 'react';

import { Base } from '@gandi/ui';

import { useFeatureFlags } from '../../../hooks/useFeatureFlag';

import styles from './ProductsList.scss';

type Props = {
  /** `children` must render `<li>` elements */
  children: React.Node,
};

export default function ProductsList({ children }: Props): React.MixedElement {
  const { FF_CART_OVERVIEW_NDS } = useFeatureFlags();

  if (FF_CART_OVERVIEW_NDS) {
    return (
      <Base
        tagName="ul"
        padding="none"
        margin="none"
        listStyleType="none"
        className={styles.root}
      >
        {children}
      </Base>
    );
  }

  // Legacy style
  return (
    <Base tagName="ul" padding="none" margin="none" listStyleType="none">
      {children}
    </Base>
  );
}
